__turbopack_context__.v({
  "afterGrid": "home-module__06co2W__afterGrid",
  "aiDetails": "home-module__06co2W__aiDetails",
  "aiGrid": "home-module__06co2W__aiGrid",
  "aiLead": "home-module__06co2W__aiLead",
  "author": "home-module__06co2W__author",
  "authorName": "home-module__06co2W__authorName",
  "authorText": "home-module__06co2W__authorText",
  "authorTitle": "home-module__06co2W__authorTitle",
  "avatar": "home-module__06co2W__avatar",
  "brandGrid": "home-module__06co2W__brandGrid",
  "brandLabel": "home-module__06co2W__brandLabel",
  "brands": "home-module__06co2W__brands",
  "button": "home-module__06co2W__button",
  "center": "home-module__06co2W__center",
  "container": "home-module__06co2W__container",
  "cta": "home-module__06co2W__cta",
  "description": "home-module__06co2W__description",
  "detail": "home-module__06co2W__detail",
  "detailImage": "home-module__06co2W__detailImage",
  "devicePanel": "home-module__06co2W__devicePanel",
  "gallery": "home-module__06co2W__gallery",
  "galleryGroup": "home-module__06co2W__galleryGroup",
  "galleryLoop": "home-module__06co2W__galleryLoop",
  "galleryShell": "home-module__06co2W__galleryShell",
  "galleryTrack": "home-module__06co2W__galleryTrack",
  "heading": "home-module__06co2W__heading",
  "initials": "home-module__06co2W__initials",
  "integration": "home-module__06co2W__integration",
  "integrationGrid": "home-module__06co2W__integrationGrid",
  "link": "home-module__06co2W__link",
  "media": "home-module__06co2W__media",
  "oss": "home-module__06co2W__oss",
  "readMore": "home-module__06co2W__readMore",
  "review": "home-module__06co2W__review",
  "reviewActions": "home-module__06co2W__reviewActions",
  "reviewBody": "home-module__06co2W__reviewBody",
  "reviewExcerpt": "home-module__06co2W__reviewExcerpt",
  "reviews": "home-module__06co2W__reviews",
  "secondary": "home-module__06co2W__secondary",
  "section": "home-module__06co2W__section",
  "soft": "home-module__06co2W__soft",
  "source": "home-module__06co2W__source",
  "split": "home-module__06co2W__split",
  "stat": "home-module__06co2W__stat",
  "stats": "home-module__06co2W__stats",
  "template": "home-module__06co2W__template",
  "templates": "home-module__06co2W__templates",
  "title": "home-module__06co2W__title",
});
